//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AQTimeline from "@/components/Generics/AQTimeline/AQTimeline.vue";
import AQInput from "@/components/Generics/AQInput/AQInput.vue";
import AQModal from "@/components/Generics/AQModal/AQModal.vue";
import AQButton from "@/components/Generics/AQButton/AQButton.vue";

export default {
    name: "ViewAQTimeline",
    components: { AQTimeline, AQInput, AQModal, AQButton },
    data() {
        return {
            mockDataItems: null,
            modalTimeline: false,
            timelineData: null,
            dataItems: []
        };
    },

    methods: {
        noteAdded(evt) {
            alert("NoteFromViewComponent", evt);
        },
        modalAction(evt) {
            if (evt === "close") {
                this.modalTimeline = false;
            }
        },
        menuClicked(evt) {
            console.log("menu click - event = ", evt);
        },
        itemClicked(evt) {
            console.log("item click - event = ", evt);
        },

        valueChanged() {
            this.mockDataItems = this.timelineData ? JSON.parse(this.timelineData) : [];
            this.modalTimeline = true;
        },
        resetValues() {
            this.timelineData = "";
        }
    }
};
